import React, { useEffect, useState } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import styled from 'styled-components';
import WhitePad from '../../../../../components/common/WhitePad/WhitePad';
import TitleComponent from '../../../../../components/common/forms/Title/TitleComponent';

import PurchaseOrdersApi from '../../../../../services/api/PurchaseOrdersApi';
import { StatusCodes } from 'http-status-codes';
import { PurchaseOrderDeliveryGetMinDto } from 'svila-common';
import DisplayDate from '~/src/components/common/DisplayDate';
import PurchaseSecondaryNavigation from '~/src/components/common/navigation/PurchaseSecondaryNavigation';
import TableWrapper from '~/src/components/common/forms/TableWrapper/TableWrapper';

import createIcon from '../../../../../static/img/createIcon.svg';
import DisplayTime from '~/src/components/common/DisplayTime';
interface ParamProps {
  id: string;
}

export default function DeliveriesList(): React.ReactElement {
  const { id } = useParams<ParamProps>();
  const history = useHistory();
  const [deliveries, setDeliveries] = useState<PurchaseOrderDeliveryGetMinDto[]>();

  const getDeliveries = async (): Promise<void> => {
    const res = await PurchaseOrdersApi.getDeliveries(id);
    if (res.status === StatusCodes.OK) {
      setDeliveries(res.data);
    }
  };

  useEffect(() => {
    if (id) {
      getDeliveries();
    }
  }, []);

  return (
    <WhitePad>
      <PurchaseSecondaryNavigation />
      <TitleComponent
        title="Delivery List"
        titleRight="Create Delivery"
        onRightHandler={(): void => history.push(`/purchase-delivery/create/${id}`)}
        iconRight={createIcon}
      />
      <TableWrapper>
        <thead>
          <tr>
            <th style={{ padding: 10, border: '1px solid gray' }}>№</th>
            <th style={{ padding: 10, border: '1px solid gray' }}>Delivery FN</th>
            <th style={{ padding: 10, border: '1px solid gray' }}>Delivery LN</th>
            <th style={{ padding: 10, border: '1px solid gray' }}>ETA</th>
            <th style={{ padding: 10, border: '1px solid gray' }}>TruckPlate</th>
            <th style={{ padding: 10, border: '1px solid gray' }}>TimeSlot</th>
            <th style={{ padding: 10, border: '1px solid gray' }}>CMR Number</th>
            <th style={{ padding: 10, border: '1px solid gray' }}>CMR Date</th>
            <th style={{ padding: 10, border: '1px solid gray' }}>Contacts</th>
            <th style={{ padding: 10, border: '1px solid gray' }}>Logistics Company</th>
            <th style={{ padding: 10, border: '1px solid gray' }}>Loading Reference</th>
          </tr>
        </thead>
        <tbody>
          {deliveries?.map((delivery, index) => {
            return (
              <RowStyle
                key={index}
                onClick={() =>
                  history.push({
                    pathname: `/purchase-delivery/edit/${delivery.orderId}`,
                    state: { delivery: delivery },
                  })
                }
              >
                <td style={{ padding: 10, border: '1px solid gray' }}>{index + 1}</td>
                <td style={{ padding: 10, border: '1px solid gray' }}>{delivery.driverFirstName}</td>
                <td style={{ padding: 10, border: '1px solid gray' }}>{delivery.driverLastName}</td>
                <td style={{ padding: 10, border: '1px solid gray' }}>
                  <DisplayDate date={delivery.eta} />
                </td>
                <td style={{ padding: 10, border: '1px solid gray' }}>{delivery.truckPlate}</td>
                <td style={{ padding: 10, border: '1px solid gray' }}>
                  <DisplayTime time={delivery.timeSlot} />
                </td>
                <td style={{ padding: 10, border: '1px solid gray' }}>{delivery.cmrNumber}</td>
                <td style={{ padding: 10, border: '1px solid gray' }}>
                  <DisplayDate date={delivery.cmrDate} />
                </td>
                <td style={{ padding: 10, border: '1px solid gray' }}>{delivery.contacts}</td>
                <td style={{ padding: 10, border: '1px solid gray' }}>{delivery.logisticsCompany}</td>
                <td style={{ padding: 10, border: '1px solid gray' }}>{delivery.loadingReference.slice(-6)}</td>
              </RowStyle>
            );
          })}
        </tbody>
      </TableWrapper>
    </WhitePad>
  );
}

const RowStyle = styled.tr`
  cursor: pointer;
`;

const TableWidth = styled.table`
  width: 100%;
`;
